import { AuxiliumComponent } from "../auxilium-component";

export default class TreeItem extends AuxiliumComponent {
	static observable = ["icon-colour", "icon", "link", "default"];
	static observableBooleans = ["open", "allow-open"];

	#refItem = null;

	get #referenceItem() {
		return this.#refItem ??= this.closest("[role='treeitem']");
	}

	#PlaceButton() {
		if (this.querySelector(".tree__toggle")) { return; }

		const actualContent = [...this.childNodes ?? []].filter(x => !x.matches?.("chip-tree, chip-treeitem, chip-actionbar")),
			buttonContent = this.arrowCollapse ? [] : actualContent;

		const button = document.createElementWithContents("chip-button", buttonContent.find(x => x.textContent.trim()) || this.arrowCollapse ? buttonContent : document.createElementWithContents("span", this.default, { className: "text-faded" }), {
			variation: "none",
			className: "tree__toggle",
			description: "Toggle tree item",
			link: this.link
		});

		if (this.arrowCollapse) {
			Object.assign(button, {
				buttonStyle: "icon",
				icon: "fas fa-chevron-right"
			});

			if (!actualContent.find(x => x.innerText?.trim() || x.textContent.trim()) && this.default) {
				this.prepend(document.createElementWithContents("span", this.default, { className: "text-faded" }));
			}
		}

		if (this.icon) {
			if (this.arrowCollapse) {
				const newIcon = document.createElementWithContents("chip-icon", null, { icon: this.icon });
				newIcon.classList.add("tree-item__icon");

				if (this.iconColour) {
					newIcon.dataset.colour = this.iconColour;
					newIcon.classList.add("text-theme");
				}

				this.prepend(newIcon);
			} else {
				button.icon = this.icon;

				if (this.iconColour) { button.iconColour = this.iconColour; }
			}
		}

		if (this.#referenceItem) {
			this.#referenceItem.ariaExpanded = this.open.toString();
		}

		button.onclick = () => this.#UpdateOpenState();

		if (!this.arrowCollapse || this.querySelector("chip-tree, chip-treeitem")) {
			this.prepend(button);
		}
	}

	parsedCallback() {
		this.arrowCollapse = !!this.closest("chip-tree[arrow-collapse]");

		if (!this.allowOpen) {
			this.allowOpen = !!this.querySelector("chip-tree");
		}

		if (this.allowOpen || this.link || !!this.querySelector("chip-tree")) {
			this.#PlaceButton();
		} else {
			if (!this.textContent?.trim()) { this.prepend(document.createElementWithContents("span", this.default, { className: "text-faded" })); }

			if (this.icon) {
				const icon = document.createElementWithContents("chip-icon", null, { icon: this.icon });

				if (this.iconColour) {
					icon.dataset.colour = this.iconColour;
				}

				this.prepend(icon);
			}
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "allow-open" && this.IsAttributeValueTrue(newValue) && !this.querySelector(".tree__toggle")) {
			this.querySelector(":scope > chip-icon")?.remove();

			this.#PlaceButton();
		}
	}

	AddItem(item) {
		const tree = this.querySelector(":scope > chip-tree");

		if (tree) {
			tree.AddItem(item);
		} else {
			this.appendChild(document.createElementWithContents("chip-tree", item));

			this.allowOpen = true;
		}
	}

	#UpdateOpenState() {
		if (this.#referenceItem.ariaExpanded !== "true") {
			this.raiseEvent("open");
		}

		this.#referenceItem.ariaExpanded = this.#referenceItem.ariaExpanded === "false";
	}
}
